import _get from 'lodash/get';
import { BLOCKS } from '@contentful/rich-text-types';

export const getDescription = worksheet => {
  const mainRichText = _get(worksheet.fields, 'introduction');
  const content = _get(mainRichText, 'content', []);

  const stepChecker = item =>
    item.nodeType === BLOCKS.PARAGRAPH &&
    _get(item.content, '0.value').includes('#step');

  const firstStepIdx = content.findIndex(stepChecker);

  return {
    content: content.slice(0, firstStepIdx),
  };
};

const stepChecker = item =>
  item.nodeType === BLOCKS.PARAGRAPH &&
  _get(item.content, '0.value').includes('#step');

const viewChecker = item => item.nodeType === BLOCKS.HR;

export const createSteps = worksheet => {
  const mainRichText = _get(worksheet.fields, 'introduction');
  const context = _get(worksheet.fields, 'context');
  const content = _get(mainRichText, 'content', []);
  const stepsData = [];
  let viewIdx = 0;
  let isInView = false;
  let currentStepIdx = -1;

  content.forEach(item => {
    if (stepChecker(item)) {
      currentStepIdx += 1;
      isInView = true;
      viewIdx = 0;

      stepsData.push({
        ..._get(context, ['steps', currentStepIdx]),
        views: [],
      });
    } else if (viewChecker(item)) {
      viewIdx += 1;
    } else if (isInView) {
      if (_get(stepsData[currentStepIdx], ['views', viewIdx, 'content'])) {
        stepsData[currentStepIdx].views[viewIdx].content.push(item);
      } else {
        stepsData[currentStepIdx].views[viewIdx] = {
          content: [item],
        };
      }
    }
  });

  return stepsData;
};

export const isQuestionAnswered = (answers, question) => {
  const questionAnswers = answers[question.name];
  if (!questionAnswers) {
    return false;
  }

  if (question.type === 'accordion') {
    return Object.values(questionAnswers).some(Boolean);
  }

  if (question.type === 'checkbox') {
    return (
      !!questionAnswers.length &&
      questionAnswers.length <= _get(question, 'maxCount', 5)
    );
  }

  return Array.isArray(questionAnswers)
    ? questionAnswers.some(Boolean)
    : !!questionAnswers?.length;
};

export const isViewQuestionAnswered = ({
  answers,
  stepData,
  activeViewIdx,
}) => {
  const viewQuestions = stepData.questions.filter(
    q => (q.viewIdx ?? 0) === activeViewIdx,
  );

  return (
    !viewQuestions.length ||
    viewQuestions.every(q => isQuestionAnswered(answers, q))
  );
};

export const getNextProgressIdx = ({
  steps,
  activeStep,
  activeViewIdx,
  isLastStep,
}) => {
  const stepData = steps[activeStep];
  let nextViewIdx = activeViewIdx + 1;
  let nextStepIdx = activeStep;

  if (!stepData.views[nextViewIdx]) {
    nextStepIdx = isLastStep ? steps.length - 1 : activeStep + 1;
    nextViewIdx = isLastStep ? activeViewIdx : 0;
  }

  return {
    nextStepIdx,
    nextViewIdx,
  };
};

export const parsePlaceholder = placeholder => {
  const questionId = /#(\w+)/.exec(placeholder)?.[1];
  const isAnswer = placeholder.endsWith('-answer');
  return { questionId, isAnswer };
};
